import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Dialog, DialogContent, DialogTitle,
  Grid,
  Box,
  InputAdornment,
  TextField as Input,
  CircularProgress,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Modal
} from '@material-ui/core'

import Widget from '../../components/Widget/Widget'
import { Typography } from '../../components/Wrappers/Wrappers'

import useStyles from "./styles";
import moment from 'moment'


//context
// import { usePagesState} from "../../context/PagesContext";

import { getfeedback, FeedbackState } from '../../context/FeedbackContext';


// Icons
import {
  Search as SearchIcon
} from '@material-ui/icons'
import config from "../../config";

// import Modal from '@mui/material/Modal';


//Function to sort data
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

//Table headings
const headCells = [
  { numeric: true, disablePadding: false, label: '#', sort: false, center: false },
  { id: "full_name", numeric: false, disablePadding: false, label: "FULLNAME", sort: true, center: true },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL", sort: true, center: true },
  { id: "app_version", numeric: false, disablePadding: false, label: "VERSION", sort: true, center: true },
  { id: "category", numeric: false, disablePadding: false, label: "CATEGORY", sort: true, center: true },
  { id: "comment", numeric: false, disablePadding: false, label: "COMMENT", sort: true, center: true },
  { id: "created_on", numeric: true, disablePadding: false, label: "DATE", sort: true, center: true },
];

//It will create table heading
function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            width={headCell.width}
            key={index}
            align={headCell.center ? 'center' : headCell.numeric ? 'left' : 'right'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sort ?
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography
                  noWrap
                  weight={'medium'}
                  variant={'body2'}
                >
                  {headCell.label}
                </Typography>
              </TableSortLabel>
              :
              <Typography
                noWrap
                weight={'medium'}
                variant={'body2'}
              >
                {headCell.label}
              </Typography>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}




//Users component
const FeedBack = () => {

  const classes = useStyles();
  //  const context = usePagesState();

  const context = FeedbackState();

  var [feedBack, setfeedBack] = useState(context.feedBack.feedBack);


  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('created_date')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [feedBackRows, setfeedBackRows] = useState(context.feedBack.feedBack)
  const [searchVal, setSearchVal] = useState('');
  const [modalData, setModalData] = useState(null);


  //modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpenMOdal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  //modal2
  const [toggleInputModal, setToggleInputModal] = useState(false);

  // React hook which calls when page loads
  useEffect(() => {
    getfeedback(context.setfeedback)
  }, []);

  // React hook which calls when context value change
  useEffect(() => {
    setfeedBack(context.feedBack.feedBack);
    setfeedBackRows(context.feedBack.feedBack);
  }, [context]);


  //Function to store Sort by and property to sort
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  //Function to call when pagination value change
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  //Function to set value of rows per page
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }


  // Function to search
  const handleSearch = e => {
    let value = e.currentTarget.value.replace(/^\s+/, "")
    setSearchVal(value)
    setPage(0)
    const newArr = feedBackRows.data.filter(c => {
      return c.full_name && c.email && (c.full_name.toLowerCase().includes(value.toLowerCase()) || c.email.toLowerCase().includes(value.toLowerCase()))
    })
    setfeedBack({ isLoaded: true, data: newArr })
  }

  const Modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



  const closeModal = () => {
    setToggleInputModal(false)
  }

  return (
    <>


      {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script> */}

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Widget inheritHeight>
            <Grid container spacing={5}>

              <Grid item md={4} xs={4} sm={4}>
                <Box>
                  <span className={classes.mainPageTitle}><b>Feedback</b>
                  </span>
                </Box>
              </Grid>

              <Grid item md={4} xs={4} sm={4}>
              </Grid>


              <Grid md={4} xs={4} sm={4} >
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'flex-end'}
                  marginRight={'5px'}
                  marginTop={'10px'}
                >
                  <Input
                    fullWidth
                    id="search-field"
                    // label="Search"
                    margin="dense"
                    variant="outlined"
                    onChange={(e) => handleSearch(e)}
                    value={searchVal}
                    placeholder='Search By Name or Email'
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

              </Grid>

            </Grid>
          </Widget>

        </Grid>

        {!context.feedBack.isLoaded || !feedBack.data ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            width={"100vw"}
            height={"calc(100vh - 200px)"}
          >
            <CircularProgress size={50} />
          </Box>
        ) : (

          <div className='smallTable feedbackTable'>
            <Grid item xs={12}>
              <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                  <Table
                    aria-labelledby="tableTitle"
                    aria-label="enhanced table">

                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={feedBack.data.length}
                    />
                    {
                      feedBack.data &&
                        feedBack.data.length > 0 ?

                        <TableBody>
                          {stableSort(feedBack.data, getComparator(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                              return (
                                <TableRow

                                  hover
                                  tabIndex={-1}
                                  key={index}
                                >

                                  <TableCell
                                    component="th"
                                    scope="row"
                                  // onClick={() => redirectToDetails(row.id)}
                                  >
                                    <Typography variant={'body2'}>
                                      {(page * rowsPerPage) + index + 1}
                                    </Typography>
                                  </TableCell>

                                  <TableCell  ><Typography variant={'body2'} style={{ textAlign: "center" }}> {row.full_name}</Typography></TableCell>
                                  <TableCell  ><Typography variant={'body2'} style={{ textAlign: "center" }}> {row.email}</Typography></TableCell>
                                  <TableCell  ><Typography variant={'body2'} style={{ textAlign: "center" }}> {row.app_version}</Typography></TableCell>
                                  <TableCell  ><Typography variant={'body2'} style={{ textAlign: "center" }}> {row.category}</Typography></TableCell>


                                  <TableCell align={'center'}>
                                    {/* <button id="companyEditModal" className='btn btn-primary' onClick={() => setToggleInputModal(true)} style={{ color: 'blue', cursor: "pointer" }} >View</button>
                                    <button id="companyEditModal" className='btn btn-primary' >View</button> */}


                                    <span data-bs-toggle="modal" data-bs-target="#exampleModal" style={{ color: 'blue', cursor: "pointer" }} onClick={() => { setModalData(row.comment) }}>
                                      View
                                    </span>


                                    <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                      <div class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                          <div class="modal-header">
                                            <h5 class="modal-title" id="staticBackdropLabel"> Comment </h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                          </div>
                                          <div class="modal-body">
                                            <div className='comment'>
                                              {modalData}
                                            </div>
                                          </div>
                                          <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>



                                  </TableCell>


                                  <TableCell> <Typography variant={'body2'} style={{ textAlign: "center" }} > {moment(row.created_on).format("DD-MMM-YYYY")} </Typography> </TableCell>

                                </TableRow>

                              );
                            })}
                        </TableBody>
                        :
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={headCells.length}>
                              <Typography
                                style={{ textAlign: 'center', padding: '10px 0px' }}
                                noWrap
                                variant={'h4'}>No Records</Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                    }
                  </Table>

                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={config.defaultRowsPerPage}
                  component="div"
                  count={feedBack.data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </div>
        )}
      </Grid>


    </>
  )
}



export default withRouter(FeedBack);
